<mat-sidenav-container class="dashboard-container" [hasBackdrop]="true">
  <mat-sidenav class="fixed" #drawer [mode]="'over'" position="start">
    <app-organizations
      [profile]="profile() || undefined"
      (logout)="onLogout()"
      (close)="drawer.toggle()"
      (selected)="onOrganizationSelected($event)"
    ></app-organizations>
  </mat-sidenav>
  <section class="header-container">
    <mat-toolbar>
      <mat-toolbar-row>
        <div class="dashboard-header__content">
          <div class="left">
            <button mat-icon-button (click)="drawer.toggle()" aria-label="Menu">
              <mat-icon>menu</mat-icon>
            </button>
            <h3>{{ currentOrganization()?.description }}</h3>
          </div>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
  </section>
  <section class="content-container">
    <mat-tab-group
      class="dashboard-tabs"
      animationDuration="0ms"
      [dynamicHeight]="true"
      [selectedIndex]="selectedTabIndex"
      (selectedIndexChange)="onSelectedTabIndex($event)"
    >
      <mat-tab label="CONTACTS & ALERTING">
        <div class="contact provider-contact">
          <app-dashboard-section-header
            [headerText]="subjectSingular()"
            [hideAddButton]="true"
            [hideCollapseButton]="true"
          >
            <div class="white-background-content patient-section">
              <div class="section-container patient-info-container patient-info-container--context">
                <div class="patient-info-block">
                  <div class="patient-info-line">
                    <span class="patient-name info-header headline">
                      {{ (route.queryParams | async)?.['patientName'] || '' }}
                    </span>
                    <span class="patient-phone info-subheader">
                      @if (patientSelfContacts().length > 0) {
                        {{ formatContactNumber(patientSelfContacts()[0].contactNumber) }}
                      } @else if (patientContact && patientContact.length > 0 && patientContact[0].contactNumber) {
                        {{ formatContactNumber(patientContact[0].contactNumber) }}
                      } @else {
                        No registered phone number
                      }
                    </span>
                  </div>
                  @if (isStandaloneMode) {
                    <p class="account-callback">
                      @if (loadingProviderContacts()) {
                        Loading callback location…
                      } @else {
                        @if (providerContact$ | async; as callback) {
                          {{ callback.name }} · {{ formatContactNumber(callback.contactNumber) }}
                        } @else {
                          Callback location is not set
                        }
                      }
                    </p>
                  }
                </div>
                @if (isStandaloneMode) {
                  <div class="alert-subject-menu">
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="alertSubjectMenu"
                      aria-label="Alert subject actions"
                    >
                      <mat-icon>more_horiz</mat-icon>
                    </button>
                    <mat-menu #alertSubjectMenu="matMenu" xPosition="before">
                      <button mat-menu-item (click)="openEditPatientDialog(alertSubjectContact())">
                        <mat-icon>edit</mat-icon>
                        <span>Edit {{ subjectSingular() }}</span>
                      </button>
                      <button mat-menu-item class="warn" (click)="archivePatient(alertSubjectContact())">
                        <mat-icon [color]="'warn'">archive</mat-icon>
                        <span>Archive {{ subjectSingular() }}</span>
                      </button>
                    </mat-menu>
                  </div>
                }
              </div>
            </div>
          </app-dashboard-section-header>

          @if (!isStandaloneMode) {
          <app-dashboard-section-header
            [headerText]="'Callback Location'"
            [hideAddButton]="true"
            [hideCollapseButton]="true"
          >
            @if (loadingProviderContacts() === true) {
              <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
            } @else {
              <div class="white-background-content">
                @if (providerContacts() && providerContacts().length > 0) {
                  <div class="callback-location-select-wrap">
                    <mat-form-field appearance="fill" class="full-width callback-location-select">
                      <mat-label>Select callback location</mat-label>
                      <mat-select
                        [value]="providerContact$ | async"
                        [compareWith]="compareCallbackLocations"
                        (selectionChange)="onProviderSelectionChange($event.value)"
                        panelClass="callback-location-select-panel"
                        aria-label="Callback location"
                      >
                        <mat-select-trigger>
                          @if (providerContact$ | async; as selected) {
                            <span class="callback-option-row">
                              <span class="callback-option-text">
                                <span class="callback-option-name">{{ selected.name }}</span>
                                <span class="callback-option-phone">{{
                                  formatContactNumber(selected.contactNumber)
                                }}</span>
                              </span>
                              @if (isDefaultCallbackLocation(selected)) {
                                <span class="callback-default-badge">Default</span>
                              }
                            </span>
                          }
                        </mat-select-trigger>
                        @for (contact of providerContacts(); track trackCallbackLocation(contact)) {
                          <mat-option [value]="contact">
                            <span class="callback-option-row">
                              <span class="callback-option-text">
                                <span class="callback-option-name">{{ contact.name }}</span>
                                <span class="callback-option-phone">{{
                                  formatContactNumber(contact.contactNumber)
                                }}</span>
                              </span>
                              @if (isDefaultCallbackLocation(contact)) {
                                <span class="callback-default-badge">Default</span>
                              }
                            </span>
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                } @else {
                  <p class="empty-message">
                    There are no callback locations for this {{ subjectWord() }}.
                  </p>
                }
              </div>
            }
          </app-dashboard-section-header>
          }

          <app-dashboard-section-header
            [headerText]="subjectSingular() + ' Contacts'"
            [hideAddButton]="false"
            (addNew)="openContactDialog(null, true)"
          >
            @if (loadingEmergencyContacts() !== true) {
              <div class="white-background-content">
                <div class="patient-info">
                  <mat-icon>info</mat-icon>
                  <p>
                    By using AFAS to call or message, you confirm that the recipient has given prior
                    consent to receive communications.
                  </p>
                </div>
                @if (alertContacts().length > 0) {
                  @for (contact of alertContacts(); track contact.contactNumber) {
                    @let callState = (phoneCallStates$ | async)?.[contact.contactNumber];
                    <patient-contact-element
                      class="full-width"
                      [subjectLabel]="subjectSingular()"
                      [providerSelected]="isProviderSelected()"
                      [contact]="contact"
                      [contactNumber]="formatContactNumber(contact.contactNumber)"
                      [ongoing]="callState?.state === 'inProgress'"
                      [ongoingEndTime]="callState?.activeUntil || undefined"
                      [initiatedOn]="callState?.initiatedOn"
                      [followUps]="callState?.followUps"
                      [retryAttempts]="callState?.retryAttempts"
                      [lastAttemptAt]="callState?.lastAttemptAt"
                      [nextAlertAt]="callState?.nextAlertAt"
                      [scheduledEndAt]="callState?.scheduledEndAt"
                      [sequenceId]="callState?.sequenceId"
                      [stopping]="cancellingContactNumber() === contact.contactNumber"
                      (openAlertLog)="openAlertLogRecord($event)"
                      (notifyEvent)="notify()"
                      (cancelNotification)="cancelNotify($event)"
                      (contactSelected)="onPatientSelectionChange(contact)"
                      (editPatient)="openEditPatientDialog($event)"
                      (archivePatient)="archivePatient($event)"
                      (deleteContact)="deleteContact($event, true)"
                      (editContact)="openContactDialog($event, true)"
                    ></patient-contact-element>
                  }
                } @else {
                  <p class="empty-message">There are no contacts for this {{ subjectWord() }}.</p>
                }
              </div>
            } @else {
              <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
            }
          </app-dashboard-section-header>
        </div>
      </mat-tab>
      <mat-tab label="ALERT LOG">
        <app-dashboard-section-header
          [headerText]="'Alert Log'"
          [hideAddButton]="true"
          [hideCollapseButton]="true"
          [showRefreshButton]="true"
          [refreshing]="loadingCallSequences()"
          (refresh)="refreshAlertLog()"
        ></app-dashboard-section-header>
        <app-alert-status-legend></app-alert-status-legend>
        <div class="white-background-content">
          @if (loadingCallSequences()) {
            <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
          } @else if (callSequences() && callSequences()!.length > 0) {
            <div class="alert-log-list">
              <div class="alert-log-list__head alert-log-row">
                <button
                  type="button"
                  class="alert-log-list__sort alert-log-row__when"
                  [class.alert-log-list__sort--active]="alertLogSortKey() === 'initiatedOn'"
                  (click)="toggleAlertLogSort('initiatedOn')"
                >
                  <span>Date</span>
                  @if (alertLogSortIcon('initiatedOn'); as icon) {
                    <mat-icon aria-hidden="true">{{ icon }}</mat-icon>
                  }
                </button>
                <button
                  type="button"
                  class="alert-log-list__sort alert-log-row__contact"
                  [class.alert-log-list__sort--active]="alertLogSortKey() === 'contact'"
                  (click)="toggleAlertLogSort('contact')"
                >
                  <span>Contact</span>
                  @if (alertLogSortIcon('contact'); as icon) {
                    <mat-icon aria-hidden="true">{{ icon }}</mat-icon>
                  }
                </button>
                <button
                  type="button"
                  class="alert-log-list__sort alert-log-row__campaign"
                  [class.alert-log-list__sort--active]="alertLogSortKey() === 'campaign'"
                  (click)="toggleAlertLogSort('campaign')"
                >
                  <span>Campaign</span>
                  @if (alertLogSortIcon('campaign'); as icon) {
                    <mat-icon aria-hidden="true">{{ icon }}</mat-icon>
                  }
                </button>
                <button
                  type="button"
                  class="alert-log-list__sort alert-log-row__status"
                  [class.alert-log-list__sort--active]="alertLogSortKey() === 'status'"
                  (click)="toggleAlertLogSort('status')"
                >
                  <span>Status</span>
                  @if (alertLogSortIcon('status'); as icon) {
                    <mat-icon aria-hidden="true">{{ icon }}</mat-icon>
                  }
                </button>
              </div>
            <mat-accordion class="alert-log-accordion" displayMode="flat">
              @for (sequence of sortedCallSequences(); track sequence.id) {
                <mat-expansion-panel
                  [hideToggle]="true"
                  [expanded]="sequence.id === expandedSequenceId"
                  (opened)="expandedSequenceId = sequence.id"
                  (closed)="onAlertLogClosed(sequence.id)"
                >
                  <mat-expansion-panel-header>
                    <div class="alert-log-row alert-log-header">
                      <span class="alert-log-row__when">{{ formatCycleDate(sequence.initiatedOn) }}</span>
                      <span class="alert-log-row__contact">{{
                        sequenceContactLine(sequence)
                      }}</span>
                      <span class="alert-log-row__campaign">{{ sequenceCampaignTitle(sequence) }}</span>
                      <span class="alert-log-row__status alert-log-status">
                        <span
                          class="alert-log-badge"
                          [class.alert-log-badge--inProgress]="cycleBadge(sequence) === 'inProgress'"
                          [class.alert-log-badge--canceled]="cycleBadge(sequence) === 'canceled'"
                          [class.alert-log-badge--connected]="cycleBadge(sequence) === 'connected'"
                          [class.alert-log-badge--acknowledged]="cycleBadge(sequence) === 'acknowledged'"
                          [class.alert-log-badge--noResponse]="cycleBadge(sequence) === 'noResponse'"
                          [class.alert-log-badge--unknown]="cycleBadge(sequence) === 'unknown'"
                        >
                          {{ cycleLabel(sequence) }}
                        </span>
                        <mat-icon class="alert-log-chevron">{{
                          sequence.id === expandedSequenceId ? 'expand_more' : 'chevron_right'
                        }}</mat-icon>
                      </span>
                    </div>
                  </mat-expansion-panel-header>
                  <div class="alert-log-detail-grid">
                    <div class="alert-log-detail-grid__col">
                      <p class="alert-log-detail">
                        <span class="alert-log-detail__label">Callback Location:</span>
                        <span class="alert-log-detail__value">{{ sequenceCallbackName(sequence) }}</span>
                      </p>
                      <p class="alert-log-detail">
                        <span class="alert-log-detail__label">{{ subjectSingular() }}:</span>
                        <span class="alert-log-detail__value">{{ sequencePatientName() }}</span>
                      </p>
                      <p class="alert-log-detail">
                        <span class="alert-log-detail__label">Type:</span>
                        <span class="alert-log-detail__value">{{ sequenceTypeLabel(sequence) }}</span>
                      </p>
                    </div>
                    <div class="alert-log-detail-grid__col">
                      <p class="alert-log-detail">
                        <span class="alert-log-detail__label">Campaign Title:</span>
                        <span class="alert-log-detail__value">{{ sequenceCampaignTitle(sequence) }}</span>
                      </p>
                      <p class="alert-log-detail">
                        <span class="alert-log-detail__label">Campaign Date:</span>
                        <span class="alert-log-detail__value">{{ sequenceCampaignDate(sequence) }}</span>
                      </p>
                      <p class="alert-log-detail">
                        <span class="alert-log-detail__label">Description:</span>
                        <span class="alert-log-detail__value">{{ sequenceCampaignDescription(sequence) }}</span>
                      </p>
                    </div>
                  </div>
                  @let attempts = sequenceAttempts(sequence);
                  @for (attempt of attempts; track $index) {
                    <p class="alert-log-detail">
                      <span class="alert-log-detail__label">{{ attemptRowLabel(attempt) }}</span>
                      <span class="alert-log-detail__value">{{ formatCycleDate(attempt.at) }}</span>
                      @for (field of attempt.fields; track field.label) {
                        <span class="alert-log-detail__meta">
                          <span class="alert-log-detail__meta-label">{{ field.label }}:</span>
                          <span class="alert-log-detail__meta-value">{{ field.value }}</span>
                        </span>
                      }
                      @if (attempt.kind === 'message' && attempt.body) {
                        <button
                          type="button"
                          class="alert-log-detail__message-btn"
                          mat-icon-button
                          matTooltip="Show message"
                          (click)="showMessageBody(attempt.body)"
                        >
                          <mat-icon>sms</mat-icon>
                        </button>
                      }
                    </p>
                  }
                  @if (!attempts.length) {
                    <p class="empty-message">No voice or text attempts on this alert cycle.</p>
                  }
                  <hr class="alert-log-detail__rule" />
                  <p class="alert-log-detail alert-log-detail--id">
                    <span class="alert-log-detail__label">ID:</span>
                    <span class="alert-log-detail__value">{{ sequence.id }}</span>
                  </p>
                </mat-expansion-panel>
              }
            </mat-accordion>
            </div>
          } @else {
            <p class="empty-message">
              There are no alert cycles for this {{ subjectWord() }}.
            </p>
          }
        </div>
      </mat-tab>
    </mat-tab-group>
  </section>
</mat-sidenav-container>

<ng-template #loadingTemplate>
  <div class="loading">
    <mat-card appearance="outlined" class="place_holder">
      <mat-card-content>
        <app-skeleton
          viewBox="0 0 150 20"
          [speed]="2"
          backgroundColor="#E0DCDC"
          foregroundColor="rgba(0, 0, 0, 0.1)"
        >
          <svg:rect x="140" y="0" rx="0" ry="0" width="10px" height="9" />
          <svg:rect x="3" y="0" rx="0" ry="0" width="50%" height="9" />
          <svg:rect x="3" y="11" rx="0" ry="0" width="30%" height="9" />
        </app-skeleton>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>
